/** 路由常量集中定义，避免字符串 typo */
export const ROUTES = {
  // 公开
  LOGIN: '/login',
  OAUTH2_CALLBACK: '/oauth/callback',
  INIT: '/init',
  // 需登录
  HOME: '/',             // 默认主页：上线配置指引
  STATS: '/stats',       // 统计概览
  DOMAINS: '/domains',
  USERS: '/users',
  ALIASES: '/aliases',
  QUEUE: '/queue',
  BACKUPS: '/backups',
  AUDIT_LOGS: '/audit-logs',
  CLIENTS: '/clients',
  TEMPLATES: '/templates',
  SEND_LOGS: '/send-logs',
  DKIM: '/dkim',
  TLS: '/tls',
  MAIL_TEST: '/mail-test',
  SETTINGS: '/settings',
  // P2-P5 新增
  MAILBOX: '/mailbox',
  INBOUND_RULES: '/inbound-rules',
  RETENTION: '/retention',
  SERVER_CONFIG: '/server-config',
  ANTISPAM: '/antispam',
  API_DOCS: '/api-docs',
  RECYCLE_BIN: '/recycle-bin',
  // 详情页（列表行点击进入）
  DOMAIN_DETAIL: '/domains/:id',
  USER_DETAIL: '/users/:id',
  ALIAS_DETAIL: '/aliases/:id',
  QUEUE_DETAIL: '/queue/:id',
  BACKUP_DETAIL: '/backups/:id',
  AUDIT_LOG_DETAIL: '/audit-logs/:id',
  CLIENT_DETAIL: '/clients/:id',
  TEMPLATE_DETAIL: '/templates/:id',
  SEND_LOG_DETAIL: '/send-logs/:id',
  DKIM_DETAIL: '/dkim/:id',
} as const
export const DEFAULT_REDIRECT_AFTER_LOGIN = ROUTES.HOME
